export const PaymentProviderTypes = {
  SYSTEM: 1,
  O_TRADE: 2,
};

export const CONFIGURABLE_PAYMENT_PROVIDERS = [
  { providerType: PaymentProviderTypes.O_TRADE, name: 'OБанк!', path: 'o-trade' },
];
